var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath3377(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 250,
    viewBox: "0 0 411 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0267 0.0426783H391.458C395.204 0.069757 398.859 1.45486 401.967 4.02422C405.075 6.59358 407.496 10.2329 408.927 14.486C410.373 18.754 410.772 23.4486 410.074 27.9916C409.376 32.5345 407.611 36.7272 404.998 40.0533L274.758 201.343C262.309 216.761 247.498 228.999 231.181 237.35C214.864 245.701 197.362 250 179.686 250C162.01 250 144.508 245.701 128.191 237.35C111.873 228.999 97.063 216.761 84.6135 201.343L17.1608 117.46C9.0396 107.902 3.46483 95.5464 1.17068 82.0199C-1.12348 68.4934 -0.0294087 54.4303 4.30876 41.6827C8.59391 28.967 15.9398 18.1642 25.362 10.7219C34.7842 3.27965 45.8326 -0.446528 57.0267 0.0426783Z",
    fill: "#150958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath3377);
export default __webpack_public_path__ + "static/media/Path 3377.79cb7fd166abd6b1f305aca61a7cb7b8.svg";
export { ForwardRef as ReactComponent };